const resources = {
    playVideo: 'play video',
    love: 'love',
    unlove: 'unlove',
    loves: 'loves'
};

module.exports = function getResource(label) {
    return resources[label];
};
